var prefix = 'fal';
var iconName = 'hybrid-fuel';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = undefined;
var svgPathData = 'M640,184V328a24,24,0,0,1-24,24h-8v16a48,48,0,0,1-48,48H512.782a225.941,225.941,0,0,0,9.714-32H560a16.017,16.017,0,0,0,16-16V320h32V192H576V144a16.017,16.017,0,0,0-16-16H436.054c-6.7-10.177-13.289-20.75-19.646-32H560a48,48,0,0,1,48,48v16h8A24,24,0,0,1,640,184ZM48,384a16.017,16.017,0,0,1-16-16V144a16.017,16.017,0,0,1,16-16H171.922c6.692-10.187,13.281-20.764,19.631-32H48A48,48,0,0,0,0,144V368a48,48,0,0,0,48,48H95.218A225.941,225.941,0,0,1,85.5,384ZM333.22,22.09C380.21,180.57,480,222.16,480,333.91,480,432.35,401.28,512,304,512S128,432.35,128,333.91c0-111.19,100.01-154.06,146.78-311.82C279.23,7.2,291.62,0,303.97,0,316.61,0,329.21,7.53,333.22,22.09Zm60.1,185.05c-29.24-41.77-65.47-93.56-89.3-171.08-23.84,77.28-60,129.1-89.18,170.91C183,252.59,160,285.55,160,333.91,160,414.46,224.6,480,304,480s144-65.54,144-146.09C448,285.3,425.06,252.52,393.32,207.14ZM224,336a16,16,0,0,0-32,0A112.136,112.136,0,0,0,304,448a16,16,0,0,0,0-32A80.087,80.087,0,0,1,224,336Z';

var definition = {
    prefix: prefix,
    iconName: iconName,
    icon: [
        width,
        height,
        ligatures,
        unicode,
        svgPathData
    ]};
var faHybridFuel = definition;

export {
    definition,
    faHybridFuel,
    prefix,
    iconName,
    width,
    height,
    ligatures,
    unicode,
    svgPathData
}
